import type {
  Response,
  CompletedActivityResponse,
} from '@/lib/apollo/query/getCompletedActivitiesForUser/query'
import { parseDate } from '@/utils/date'

import type { TransformedCompletedActivityData, TransformedData } from './types'

export const toTransformedCompletedActivityData = (
  activity: CompletedActivityResponse,
): TransformedCompletedActivityData => ({
  ...activity,
  createdAt: parseDate(activity.createdAt),
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : {
        ...response.getActivitiesForUser,
        results: response.getActivitiesForUser.results.map(
          toTransformedCompletedActivityData,
        ),
      }
